import { Action, LatLng, State, StoreItem } from './types'

const getYourStore = (
  stores: StoreItem[] = [],
  selectedStoreId: number | string | null
) => {
  if (stores?.length === 0) return null
  return stores.find((store) => store.id === selectedStoreId) ?? null
}

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'INIT':
      return Object.assign({}, state, {
        stores: action.payload.stores ?? [],
      })
    case 'CHANGE_VIEW':
      return Object.assign({}, state, {
        view: action.payload,
      })
    case 'SET_POSITION':
      return Object.assign({}, state, {
        searchPosition: null,
        currentPosition: action.payload,
        yourStore: null,
        currentPositionStatus: {
          loading: false,
        },
      })
    case 'SET_STATUS_POSITION':
      return Object.assign({}, state, {
        currentPositionStatus: {
          loading: action.payload,
        },
      })
    case 'START_SORTING_STORES':
      return Object.assign({}, state, {
        stores: action.payload,
      })
    case 'SET_AS_STORE':
      return Object.assign({}, state, {
        currentPosition: null,
        yourStore: action.payload,
      })
    case 'SET_SEARCH_LOCATION':
      const results = action.payload

      if (results.length <= 0) return state

      const formatted_address = results[0]?.formatted_address
      const geometry = results[0].geometry as any

      const position: LatLng = {
        lat: geometry?.location.lat(),
        lng: geometry?.location.lng(),
      }

      return Object.assign({}, state, {
        searchPosition: formatted_address,
        currentPosition: position,
        yourStore: null,
        currentPositionStatus: {
          loading: false,
        },
      })
    default:
      return state
  }
}

export default reducer
